import styled, { css } from 'styled-components'

import { ReactComponent as DownloadCircleIcon } from '@sketch/icons/arrow-down-circle-17'

import { HAIRLINE_SHADOW, TILE_MEDIA_SIZE } from './constants'

export const AssetIconBox = styled.div(
  ({ theme }) => css`
    width: ${TILE_MEDIA_SIZE};
    height: ${TILE_MEDIA_SIZE};
    border-radius: 12px;
    margin-bottom: 10px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background: ${theme.colors.background.tertiary.C};
    color: ${theme.colors.foreground.secondary.C};
    box-shadow: ${HAIRLINE_SHADOW};
  `
)

export const DownloadIcon = styled(DownloadCircleIcon)`
  width: 32px;
  height: 32px;
`
